import Link from "next/link";
import { VFC } from "react";
import { Member } from "../../types/types";
import { StepProgressBar } from "./StepProgressBar";

interface StepProps {
  step: number;
  user: Member;
  setUser: any;
  payment: any;
  setPayment: any;
}

export const Step1: VFC<StepProps> = ({
  step,
  user,
  setUser,
  payment,
  setPayment,
}) => {
  const selectCompany = (selectedValue: boolean) => {
    setUser({ ...user, company_flag: selectedValue });
  };

  const selectIsPeriodic = (selectedValue: boolean) => {
    setPayment({ ...payment, isPeriodic: selectedValue });
  };

  return (
    <>
      <div className="l-container">
        <StepProgressBar step={step} />

        <div className="p-pageTtl">
          <div className="p-pageTtl__inner">
            <h2 className="p-pageTtl__ttl">寄付の方法</h2>
          </div>
        </div>

        <div className="p-tabs -cols2">
          <div className="p-tabs__inner">
            <ul>
              <li className={user.company_flag ? "" : "is-cr"}>
                <a onClick={() => selectCompany(false)}>
                  <span>個人</span>
                </a>
              </li>
              <li className={user.company_flag ? "is-cr" : ""}>
                <a onClick={() => selectCompany(true)}>
                  <span>法人</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="l-container">
        <div className="p-form">
          <div className="p-form__borderInner">
            <div className="p-form__item">
              <div className="p-form__input -radio2">
                <label>
                  <input
                    name="r1"
                    type="radio"
                    checked={payment["isPeriodic"] === true}
                    onChange={() => {
                      selectIsPeriodic(true);
                    }}
                  />
                  <span>マンスリーサポーター（毎月・定額）</span>
                </label>
              </div>
            </div>

            <div className="p-form__item">
              <div className="p-form__input -radio2">
                <label>
                  <input
                    name="r1"
                    type="radio"
                    checked={payment["isPeriodic"] === false}
                    onChange={() => {
                      selectIsPeriodic(false);
                    }}
                  />
                  <span>今回（１回）のみ寄付</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
